import { render, staticRenderFns } from "./EsgOrderCompleted.vue?vue&type=template&id=5d5865ee&scoped=true&"
import script from "@/scripts/Mall/ESG/EsgOrderCompleted/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Mall/ESG/EsgOrderCompleted/index.js?vue&type=script&lang=js&"
import style0 from "./EsgOrderCompleted.vue?vue&type=style&index=0&id=5d5865ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5865ee",
  null
  
)

export default component.exports